import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useSetAtom } from 'jotai';
import { Button } from '@/components/Button';
import { Textarea } from '@/components/Textarea';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { candidateInterviewTranscriptAtom } from '../atom/candidatesAtom';

type Props = {
  candidateProfileId: number;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export default function CandidatesInterviewTranscriptDialog({
  candidateProfileId,
  isOpen,
  onOpenChange,
}: Props) {
  const [transcript, setTranscript] = useState('');
  const setInterviewTranscript = useSetAtom(candidateInterviewTranscriptAtom);
  const navigate = useNavigate();

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) setTranscript('');
    onOpenChange(nextOpen);
  };

  const handleSubmit = () => {
    setInterviewTranscript(transcript.trim());
    handleOpenChange(false);
    navigate({
      to: '/agent/candidates/$candidateProfileId/interview_logs/new',
      params: { candidateProfileId: String(candidateProfileId) },
      search: { source: 'transcript' },
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="w-[860px] max-w-full overflow-hidden rounded-sm shadow-layer3!">
        <DialogTitle className="border-b border-solid border-border px-lg py-md text-heading-xs! text-main">
          面談の文字起こしを追加
        </DialogTitle>
        <div className="p-lg">
          <Textarea
            value={transcript}
            onChange={(e) => setTranscript(e.target.value)}
            placeholder="入力してください"
            className="h-[301px] resize-y text-body-xs"
          />
        </div>
        <div className="flex items-center justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button type="button" color="secondary" size="md" onClick={() => handleOpenChange(false)}>
            キャンセル
          </Button>
          <Button
            type="button"
            color="primary"
            size="md"
            disabled={!transcript.trim()}
            onClick={handleSubmit}
          >
            決定
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
